import { useState } from 'react';
import { bool, func, number, instanceOf } from 'prop-types';
import Modal from '../../../../components/common/Modal';
import { DatePickerCustom, FormError, FormLabel, InputLista } from '../../../../components/common';
import { useFormErrors } from '../../../../components/hooks';
import { VALIDATION_MESSAGE } from '../../../../consts/validationMessage';

// Baja de vehículo en un solo paso: pide fecha y motivo (obligatorios) y resuelve la baja.
// Reemplaza el ritual de cargar esos campos en el form, Guardar y recién ahí Baja.
const BajaVehiculoModal = ({ show, fechaAlta, fechaBaja, idMotivoBajaVehiculo, onConfirm, onDismiss }) => {

    const [values, setValues] = useState({
        fechaBaja: fechaBaja ?? null,
        idMotivoBajaVehiculo: idMotivoBajaVehiculo ?? 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    function getErrors() {
        const errors = {};

        if (values.fechaBaja == null) errors.fechaBaja = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (values.idMotivoBajaVehiculo <= 0) errors.idMotivoBajaVehiculo = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    const handleConfirm = () => {
        if (!validate()) return;

        onConfirm(values.fechaBaja, values.idMotivoBajaVehiculo);
    };

    const footer = (
        <>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => onDismiss()}>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal"
                    onClick={handleConfirm}>Dar de baja</button>
        </>
    );

    return (
        <Modal
            size="md"
            title="Baja de cuenta"
            show={show}
            onEscape={() => onDismiss()}
            footer={footer}
            body={(
                <>
                    <p>Al aceptar el cambio se procederá con la baja de la cuenta.</p>
                    <div className="row form-basic">
                        <div className="col-12 col-md-5 mb-3">
                            <FormLabel htmlFor="fechaBaja" required>Fecha de baja</FormLabel>
                            <DatePickerCustom
                                name="fechaBaja"
                                className={`form-control ${errorOf('fechaBaja') ? 'is-invalid' : ''}`}
                                value={values.fechaBaja}
                                onChange={({ target }) => setValues(prev => ({ ...prev, fechaBaja: target.value }))}
                                minValue={fechaAlta}
                            />
                            <FormError message={errorOf('fechaBaja')} />
                        </div>
                        <div className="col-12 col-md-7 mb-3">
                            <FormLabel htmlFor="idMotivoBajaVehiculo" required>Motivo de baja</FormLabel>
                            <InputLista
                                name="idMotivoBajaVehiculo"
                                className={`form-control ${errorOf('idMotivoBajaVehiculo') ? 'is-invalid' : ''}`}
                                value={values.idMotivoBajaVehiculo}
                                onChange={({ target }) => setValues(prev => ({ ...prev, idMotivoBajaVehiculo: target.value }))}
                                lista="MotivoBajaVehiculo"
                            />
                            <FormError message={errorOf('idMotivoBajaVehiculo')} />
                        </div>
                    </div>
                </>
            )}
        />
    );
};

BajaVehiculoModal.propTypes = {
    show: bool,
    fechaAlta: instanceOf(Date),
    fechaBaja: instanceOf(Date),
    idMotivoBajaVehiculo: number,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired
};

BajaVehiculoModal.defaultProps = {
    show: true,
    fechaAlta: null,
    fechaBaja: null,
    idMotivoBajaVehiculo: 0
};

export default BajaVehiculoModal;
